import React from 'react'
import {BsClipboardCheck, BsClipboardData } from 'react-icons/bs'
import {LuLayoutDashboard,LuDollarSign, LuRuler} from 'react-icons/lu'
import { useTranslation } from 'react-i18next'
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { FaFileAlt, FaClipboardList  } from 'react-icons/fa'
import { MdOutlineArticle , MdInventory } from 'react-icons/md'

const UnitsNavbar = ({tabActive,setTabActiive}) => {
    const [t,i18n ] = useTranslation('global')
  const isRTL = i18n.dir() === 'rtl';

    return (
        <>
            <div className='w-full flex mt-3 gap-3  border-b'>
                <div onClick={()=>setTabActiive('Units')} className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-t-lg text-slate-500  p-3 hover:bg-indigo-50 hover:font-bold cursor-default ${tabActive === 'Units' ? ' bg-slate-100 text-indigo-800 font-bold' : 'bg-slate-50'}`}>
                    <LuRuler   size={28}/>
                    <hr />
                    <span className='text-sm '> 
                        {t('Warehouse_settings.Unit Settings')}
                        
                         </span>
                </div>
                {/* <div onClick={()=>setTabActiive('requisition_report')} className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-t-lg text-slate-500  p-3 hover:bg-indigo-50 hover:font-bold cursor-default ${tabActive === 'requisition_report' ? ' bg-slate-100 text-indigo-800 font-bold' : 'bg-slate-50'}`}>
                    <MdOutlineArticle   size={28}/>
                    <hr />
                    <span className='text-sm '> {t('reports.requisition_report')}  </span>
                </div> */}
                 {/* <div onClick={()=>setTabActiive('Product_Report')} className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-t-lg text-slate-500  p-3 hover:bg-indigo-50 hover:font-bold cursor-default ${tabActive === 'Product_Report' ? 'bg-slate-100 text-indigo-800 font-bold' : 'bg-slate-50'}`}>
                    <BsClipboardCheck  size={28}/>
                    <hr />
                    <span className='text-sm  '>{t('reports.Product_Report')}</span>
                </div>  */}
                {/* <div onClick={()=>setTabActiive('stocktakings_report')} className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-t-lg text-slate-500  p-3 hover:bg-indigo-50 hover:font-bold cursor-default ${tabActive === 'stocktakings_report' ? 'bg-slate-100 text-indigo-800 font-bold' : 'bg-slate-50'}`}>
                    <BsClipboardData    size={28}/>
                    <hr />
                    <span className='text-sm '>{t('reports.stocktakings_report')}</span>
                </div>  */}
                {/* <div onClick={()=>setTabActiive('Tags')} className={`flex-1 flex flex-col gap-1 items-center justify-center rounded-t-lg text-slate-500  py-3 p-3 hover:bg-indigo-50 hover:font-bold cursor-default ${tabActive==='Tags' ? 'bg-slate-100 text-indigo-800 font-bold' :  'bg-slate-50'}`}>
                    <BsFillTagsFill size={28}/>
                    <hr />
                    <span className='text-sm '>   {t('product.tags')} </span>
                </div> */}
            </div>
        </>
    )
}

export default UnitsNavbar